"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDesignMonthsMaxCommit = parseDesignMonthsMaxCommit;
exports.planDesignMonths = planDesignMonths;
exports.classifyPlanSelection = classifyPlanSelection;
const plan_catalog_js_1 = require("./plan-catalog.js");
function parseDesignMonthsMaxCommit(maxCommit) {
    if (maxCommit === 'unlimited') {
        return Number.POSITIVE_INFINITY;
    }
    const parsed = Number.parseInt(maxCommit, 10);
    return Number.isNaN(parsed) ? 0 : parsed;
}
function planDesignMonths(maxCommit) {
    const parsed = parseDesignMonthsMaxCommit(maxCommit);
    return Number.isFinite(parsed) ? parsed : 1;
}
function classifyPlanSelection(current, candidate) {
    if (current.alias === plan_catalog_js_1.FREE_PLAN_KEY) {
        return 'choose';
    }
    if (current.alias === candidate.alias && candidate.designMonths === current.designMonthsCommitted) {
        return 'current';
    }
    return candidate.designMonths < current.designMonthsCommitted ? 'downgrade' : 'upgrade';
}
//# sourceMappingURL=plan-comparison.js.map